import script from "./MindMap.vue?vue&type=script&setup=true&lang=js"
export * from "./MindMap.vue?vue&type=script&setup=true&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=0c1d4f1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1d4f1a"]])

export default __exports__